import { render } from "./vminipluswecom.vue?vue&type=template&id=f8e56b7c&scoped=true"
import script from "./vminipluswecom.vue?vue&type=script&lang=js"
export * from "./vminipluswecom.vue?vue&type=script&lang=js"

import "./vminipluswecom.vue?vue&type=style&index=0&id=f8e56b7c&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8e56b7c"]])

export default __exports__